module.exports = __webpack_public_path__ + "img/icon-comment-success.c2dd0ea6.svg";